import React from 'react'

import NavButton from './navButton'
import IconPrev from '../../../../shared/components/icons/chevronLeft'

import styles from './buttons.module.css'

const PrevButton = ({ itemId }) => (
  <NavButton keyName="ArrowLeft" itemId={itemId}>
    <IconPrev className={styles.iconPrev} />
  </NavButton>
)

export default PrevButton
